var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 1.00977C10.6675 1.00977 12.829 3.17227 12.829 5.83883C12.829 7.83883 9.2409 12.7291 7.99996 14.966C6.81027 12.8191 3.1709 7.72133 3.1709 5.83883C3.1709 3.17227 5.3334 1.00977 7.99996 1.00977ZM10.1584 5.65695C10.1584 4.46852 9.18902 3.49914 7.99996 3.49914C6.81184 3.49914 5.84246 4.46852 5.84246 5.65695C5.84246 6.84508 6.81184 7.81445 7.99996 7.81445C9.18902 7.81445 10.1584 6.84508 10.1584 5.65695Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.bf2c00181d33d5032f64f6ab4ab5efb4.svg";
export { ForwardRef as ReactComponent };